export enum Language {
  EN = 'en',
  ZH_CN = 'zh-CN',
}

export const I18N_KEY = 'I18N_KEY';
